export default __webpack_public_path__ + "static/media/VerificationIcon.09fd0e90.svg";